import * as C from '../../constants';
import router from '../../../../router';
import SkiSkistarService from '../../../../services/ski/skistar-service';
import SkiService from '../../../../services/ski/ski-service';
import TwentyService from '../../../../services/twenty-service';

export default {
  /**
   * @param commit
   */
  clearState({ commit }) {
    commit(C.SKI_SKISTAR_CLEAR_STATE);
  },

  /**
   * @param commit
   * @param dispatch
   * @returns {Promise<any | never>}
   */
  loadResorts({ commit, dispatch }) {
    commit(C.SKI_SKISTAR_RESORT_LOAD_PENDING);
    return SkiSkistarService.getResorts()
      .then((res) => {
        commit(C.SKI_SKISTAR_RESORT_LOAD_SUCCESS,
          res.data.sort((a, b) => (a.name > b.name ? 1 : -1)),
        );
        const routeParams = router.currentRoute.params;
        if (routeParams.id) {
          dispatch('setResort', parseInt(routeParams.id, 10));
        }
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_RESORT_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param dispatch
   * @param payload
   */
  setResort({ commit, state }, payload) {
    commit(C.SKI_SKISTAR_RESORT_CHANGE, payload);
    const resort = state.resorts.items.find(
      item => item.id === state.resorts.resort,
    );
    commit(C.SKI_SKISTAR_RESORT_WEBSERVICE_CHANGE, resort.webservice);
  },

  /**
   * @param resortId
   */
  chooseResort({ dispatch }, resortId) {
    dispatch('setResort', resortId);
    router.push({ path: `/ski/skistar/resorts/${resortId}` });
  },

  /**
   * @param commit
   * @param id
   * @returns {Promise<any | never>}
   */
  loadResortAccommodations({ commit, state }) {
    commit(C.SKI_SKISTAR_ACCOMMODATIONS_LOAD_PENDING);
    return SkiSkistarService.getAccommodationsByResortId(state.resorts.resort)
      .then((res) => {
        commit(C.SKI_SKISTAR_ACCOMMODATIONS_LOAD_SUCCESS, res.data);
        const subareas = [];
        const subareaIds = [];
        res.data.forEach((accommodation) => {
          if (subareaIds.indexOf(accommodation.subarea.id) === -1) {
            const subarea = accommodation.subarea;
            subareas.push({ text: subarea.name, value: subarea.id });
            subareaIds.push(accommodation.subarea.id);
          }
        });
        commit(C.SKI_SKISTAR_SUBAREAS_SET,
          subareas.sort((a, b) => (a.text > b.text ? 1 : -1)),
        );
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATIONS_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  searchAccommodations({ commit }, payload) {
    commit(C.SKI_SKISTAR_AREAS_SEARCH, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setSubarea({ commit }, payload) {
    commit(C.SKI_SKISTAR_SUBAREA_CHANGE, payload);
  },

  /**
   * @param commit
   * @param dispatch
   * @returns {Promise<any | never>}
   */
  loadSuppliers({ commit }) {
    commit(C.SKI_SKISTAR_SUPPLIER_LOAD_PENDING);
    return SkiService.getActiveSkiSuppliers()
      .then((res) => {
        commit(C.SKI_SKISTAR_SUPPLIER_LOAD_SUCCESS,
          res.data.sort((a, b) => (a.name > b.name ? 1 : -1)),
        );
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_SUPPLIER_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @returns {Promise<any | never>}
   */
  loadSites({ commit }) {
    commit(C.SKI_SKISTAR_SITES_LOAD_PENDING);
    return SkiService.getSkiSitesWithAreaAndCountry()
      .then((res) => {
        commit(C.SKI_SKISTAR_SITES_LOAD_SUCCESS,
          res.data.sort((a, b) => (a.name > b.name ? 1 : -1)),
        );
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_SITES_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param dispatch
   * @param payload
   * @returns {Promise<any | never>}
   */
  importAccommodations({ commit, state, dispatch }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_PENDING);
    const requestBody = {
      supplierId: state.suppliers.supplier,
      siteId: state.sites.site,
      accommodationCategoryId: state.accommodations.categories.category,
      xmlChannelProductIds: payload.map(accommodation => accommodation.xmlChannelProductId),
      webservice: state.resorts.webservice,
    };
    return SkiSkistarService.importAccommodations(requestBody)
      .then((res) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_SUCCESS, res.data);
        dispatch('loadStockPriceProducts');
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  setImportSupplier({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_SUPPLIER_CHANGE, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setImportSite({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_SITE_CHANGE, payload);
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<any | never>}
   */
  showAccommodationTexts({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_TEXTS_PENDING, payload);
    return SkiSkistarService.getAccommodationTexts(payload.id)
      .then((res) => {
        if (res.data) {
          commit(C.SKI_SKISTAR_ACCOMMODATION_TEXTS_SUCCESS, res.data);
        } else {
          commit(C.SKI_SKISTAR_ACCOMMODATION_TEXTS_NOCONTENT);
        }
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_TEXTS_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   */
  closeAccommodationTexts({ commit }) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_TEXTS_CLOSE);
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<any | never>}
   */
  showAccommodationImages({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGES_PENDING, payload);
    return SkiSkistarService.getAccommodationImages(payload.id)
      .then((res) => {
        if (res.data) {
          const images = {};
          res.data.forEach((image) => {
            images[image.identifier] = image;
          });
          commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGES_SUCCESS, images);
        } else {
          commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGES_NOCONTENT);
        }
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGES_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param id
   * @param identifier
   * @returns {Promise<any | never>}
   */
  activateAccommodationImage({ commit, state }, identifier) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_PENDING);
    return SkiSkistarService.activateAccommodationImage(
      state.accommodation.selected.id,
      identifier,
    )
      .then(() => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_SUCCESS, identifier);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param id
   * @param identifier
   * @returns {Promise<any | never>}
   */
  deactivateAccommodationImage({ commit, state }, identifier) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_PENDING);
    return SkiSkistarService.deactivateAccommodationImage(
      state.accommodation.selected.id,
      identifier,
    )
      .then(() => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_SUCCESS, identifier);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param id
   * @param identifier
   * @returns {Promise<any | never>}
   */
  deleteAccommodationImage({ commit, state }, identifier) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_PENDING);
    return SkiSkistarService.deleteAccommodationImage(
      state.accommodation.selected.id,
      identifier,
    )
      .then(() => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_SUCCESS, identifier);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   */
  closeAccommodationImages({ commit }) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMAGES_CLOSE);
  },

  /**
   * @param commit
   * @param state
   * @returns {Promise<any | never>}
   */
  loadStockPriceProducts({ commit, state }) {
    commit(C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_PENDING);
    return TwentyService.getStockPriceProductsForAType(state.resorts.webservice)
      .then((res) => {
        if (res.data) {
          commit(C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_SUCCESS, res.data);
        } else {
          commit(C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_NO_CONTENT);
        }
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @returns {Promise<any | never>}
   */
  loadAccommodationCategories({ commit }) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_PENDING);
    return TwentyService.getSkiAccommodationCategories()
      .then((res) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_SUCCESS, res.data);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  setImportCategory({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_CATEGORY_CHANGE, payload);
  },

  /**
   * @param commit
   * @param state
   * @param payload
   */
  toggleAccommodationSelection({ commit, state }, payload) {
    const index = state.accommodations.selected.indexOf(payload);
    if (index !== -1) {
      commit(C.SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE, index);
    } else {
      commit(C.SKI_SKISTAR_ACCOMMODATION_SELECTION_ADD, payload);
    }
  },

  /**
   * @param commit
   * @param payload
   */
  toggleAccommodationSelectionAll({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_SELECTION_TOGGLE_ALL, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  removeImportedFromSelection({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE_IMPORTED, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  unmapAccommodation({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_UNMAP_DIALOG, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  unmapAccommodationReset({ commit }) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_UNMAP_RESET);
  },

  /**
   * @param commit
   * @param payload
   */
  unmapAccommodationFinalize({ commit, state, dispatch }) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_UNMAP_PENDING);
    return SkiSkistarService.unmapAccommodation(state.accommodations.unmap)
      .then((res) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_UNMAP_SUCCESS, res.data);
        dispatch('loadStockPriceProducts');
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_UNMAP_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  getResortAddons({ commit, state }) {
    commit(C.SKI_SKISTAR_ADDONS_RESORT_LIST_PENDING);
    return SkiSkistarService.getResortAddons(state.resorts.resort)
      .then((res) => {
        commit(C.SKI_SKISTAR_ADDONS_RESORT_LIST_SUCCESS, res.data);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ADDONS_RESORT_LIST_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param addon
   */
  updateAddonTwentyExtraId({ commit, state }, addon) {
    commit(C.SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_PENDING, addon.id);
    return SkiSkistarService.updateAddonTwentyExtraId(addon)
      .then(() => {
        const addonIndex = state.addons.items.findIndex(item => item.id === addon.id);
        commit(C.SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_SUCCESS,
          { index: addonIndex, id: addon.id, twentyExtraId: addon.twentyExtraId });
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_FAILURE,
          { id: addon.id, error: err.response.data });
      });
  },

  /**
   * @param commit
   */
  showAddonAccommodationModal({ commit }, addon) {
    commit(C.SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_SHOW, addon);
  },

  /**
   * @param commit
   */
  closeAddonAccommodationModal({ commit }) {
    commit(C.SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_CLOSE);
  },

  /**
   * @param commit
   * @param payload
   */
  searchAddons({ commit }, payload) {
    commit(C.SKI_SKISTAR_ADDONS_RESORT_SEARCH, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  loadResortSubareas({ commit, state }) {
    commit(C.SKI_SKISTAR_RESORT_SUBAREAS_PENDING);
    return SkiSkistarService.getResortSubareas(state.resorts.resort)
      .then((res) => {
        commit(C.SKI_SKISTAR_RESORT_SUBAREAS_SUCCESS, res.data);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_RESORT_SUBAREAS_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  setResortSubarea({ commit }, payload) {
    commit(C.SKI_SKISTAR_RESORT_SUBAREA_CHANGE, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setImportStatusFilter({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_FILTER_IMPORT_STATUS_CHANGE, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setImageStatusFilter({ commit }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_FILTER_IMAGE_STATUS_CHANGE, payload);
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   */
  showAccommodationImportStatus({ commit, dispatch }, payload) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_SHOW, payload);
    dispatch('loadAccommodationImportStatus');
  },

  /**
   * @param commit
   * @param state
   */
  loadAccommodationImportStatus({ commit, state }) {
    const importedProduct = state.import.status.items.find(stockPriceProduct =>
      stockPriceProduct.xmlChannelProductId === state.accommodation.selected.xmlChannelProductId,
    );
    return SkiSkistarService.getAccommodationSiteWithAccommodation(
      importedProduct.accommodationSiteId,
    )
      .then((res) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_SUCCESS, res.data);
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   */
  closeAccommodationImportStatus({ commit }) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_CLOSE);
  },

  /**
   * @param commit
   * @param state
   * @param siteId
   * @param payload
   */
  changeSiteOnAccommodation({ commit, state, dispatch }, siteId) {
    commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_PENDING);
    const importedProduct = state.import.status.items.find(stockPriceProduct =>
      stockPriceProduct.xmlChannelProductId === state.accommodation.selected.xmlChannelProductId,
    );
    return SkiSkistarService.changeSiteOnAccommodation(importedProduct.accommodationSiteId, siteId)
      .then(() => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_SUCCESS);
        dispatch('loadAccommodationImportStatus');
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_FAILURE, err.response.data);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/skistar/actions.js